export default __webpack_public_path__ + "static/INSTAR_Cloud_Alexa_Skill_00-f8409484656f9b3e8099badbc89e1902.webp";